export default "__VITE_ASSET__J6KgGPy9__"